import { campaignMetrics, ChartDataResponse, DimensionInfo, MetricInfo } from "@api/common";
import { AppState, currentReportCampaign, toPieData } from "@store";
import { FetchingState } from "rd-redux-http";
import * as React from "react";
import { connect } from "react-redux";
import { ChartWithTable } from "./ChartWithTable";
import { filterDimensionsByData } from "./filterDimensionsByData";
import { Pie } from "./PieChart";

interface DemographicAgeChartComponentProps {
    metrics: MetricInfo[];
    dimensions: DimensionInfo[];
    data: ChartDataResponse;
}

function DemographicAgeChartComponent({ metrics, dimensions, data }: DemographicAgeChartComponentProps) {
    return (
        <ChartWithTable title="Demographic" subtitle="Age" data={data} metrics={metrics} dimensions={dimensions}>
            {metric => <Pie circleWidth={10} data={toPieData(data, metric, dimensions)} />}
        </ChartWithTable>
    );
}

export const DemographicAgeChart = connect(
    (appState: AppState): DemographicAgeChartComponentProps => {
        const campaign = currentReportCampaign(appState);
        const metrics = campaignMetrics(campaign ? campaign.unit : "CPM");

        const ages = FetchingState.getDataOrDefault(appState.mappings.age, []);

        const data = FetchingState.getDataOrDefault(appState.reports.chartData.ageGroupData, {
            metrics: [],
            dimensions: []
        });

        const colors = ["#258CA1", "#09A38C", "#324472", "#F58F0E", "#E23051", "rgba(26,127,179)"];

        const dimensions = ages.map<DimensionInfo>((d, i) => ({
            dimension: d.type.toLowerCase(),
            title: d.type,
            color: colors[i]
        }));

        return {
            metrics,
            data,
            dimensions: filterDimensionsByData(dimensions, data)
        };
    }
)(DemographicAgeChartComponent);
